import axios from "axios";

export const apiEndpoint = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
